module.exports = __webpack_public_path__ + "img/leftTab001.svg";